import { render, staticRenderFns } from "./InstagramBusinessContentMediaFeed.vue?vue&type=template&id=76abbd0a"
import script from "./InstagramBusinessContentMediaFeed.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessContentMediaFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports